<!-- 获取运营积分接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "wxAppId": "wx4965abff0ba79af7",
                "parkCode": "2KKN6111",
                "mobile": "13800001111"
            },
            responseCode: {
                "data": {
                    "rule": "1:1",
                    "max": 100,
                    "pointsValue": 80
                },
                "message": "ok",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台调用第三方接口获取手机号/车牌可用的城市运营积分",
                urlPattern: this.commonUrls.third+"pointsGet",
                flow: '/static/城市运营积分.png',
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "第三方提供接口, 智慧停车开放平台主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'wxAppId', info2: '是', info3: 'String', info4: '微信公众号appId' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                        //{ info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码（与手机号码必填一个）' },
                        { info1: 'mobile', info2: '是', info3: 'String', info4: '用户手机号（与车牌号必填一个）' }
                        ]
                }],
                R_params: [{
                    titleName: "data返回数据",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                            { info1: 'rule', info2: '是', info3: 'String', info4: '抵扣规则，x（整数）运营积分抵扣y（Decimal）元，形式为"x:y"。样例"10:10.00"' },
                            { info1: 'max', info2: '是', info3: 'Integer', info4: '单次最高抵扣运营积分值' },
                            { info1: 'pointsValue', info2: '是', info3: 'Integer', info4: '预置运营积分值，为大于等于0的整数' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/points/pointsGet.vue